/** @internal */
export class Versioned {
  value;
  constructor(value) {
    this.value = value;
  }
}
//# sourceMappingURL=versioned.js.map